import React from "react";
import AdminLayout from "../../../components/layouts/adminLayout";
import AdminPageContainer from "../../../components/AdminPageContainer";
import Reassignment from "../../../Containers/AllianceManager/Reassignment";

const ReassignmentPage = () => {
  return (
    <AdminLayout>
      <AdminPageContainer>
        <Reassignment />
      </AdminPageContainer>
    </AdminLayout>
  );
};

export default ReassignmentPage;
